import { useContext, useLayoutEffect, useMemo, useState } from "react";
// import dataJson from "./income-description-list-data.json";
import CustomizerContext from "../../../../../_helper/Customizer";
import {
  DescriptionName,
  Description,
  IncomeDescription,
  IncomeCategory,
  IncomeGroup,
  IncomeClass,
  IncomeType,
  Status,
  Name,
  CreatedBy,
  ModifiedBy,
} from "../../../../../Constant";
import {
  financesIncomeCategoryApi,
  financesIncomeClassApi,
  financesIncomeDescriptionApi,
  financesIncomeGroupApi,
  financesIncomeTypeApi,
} from "../../../../../api";
import { createDropdownField } from "../../../../../Data/FormField/PublicData";
import useAxiosPrivate from "../../../../../Hooks/useAxiosPrivate";
import { IncomeDescriptionResponse } from "../IncomeDescription.types";
import useAuth from "../../../../../Hooks/useAuth";
import { toast } from "react-toastify";
import { StatusRow } from "../../ReportType/List/ReportTypeList";
import { formatDateWithTimeZone } from "../../../../../_helper/dateHelper";
export default function useIncomeDescriptionListController() {
  const axiosPrivate = useAxiosPrivate();
  const title = IncomeDescription;

  const { userOrganisationId }: any = useAuth();
  const [formFields, setFormFields] = useState<any[]>([
    {
      id: "name",
      name: "name",
      label: DescriptionName,
      type: "text",
      value: "",
      required: true,
      colSize: 6,
    },

    {
      id: "description",
      name: "description",
      label: Description,
      type: "textarea",
      value: "",
      required: true,
      colSize: 6,
    },
    {
      id: "is_active",
      name: "is_active",
      label: Status,
      type: "switch",
      value: "1",
      colSize: 6,
    },
  ]);

  //?? DROPDOWNS INITS >
  const incomeCategoryDropDown = createDropdownField(
    axiosPrivate,
    "income_category_id",
    "income_category_id",
    IncomeCategory,
    `${financesIncomeCategoryApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}`,
    6
  );
  incomeCategoryDropDown.onChange = async (id, updatedFields) => {
    const nextField = updatedFields.find(
      (field: any) => field.id === "income_group_id"
    );
    if (nextField) {
      const endPoint = `${financesIncomeGroupApi}?organisation_id=${userOrganisationId}&income_category_id=${id}`
      await nextField.fetchOptions(id, false, endPoint);
      const updatedFormFields = updatedFields.map((field: any) => {
        if (field.id === "income_category_id") {
          return { ...field, value: id };
        }
        return field;
      });
      setFormFields([...updatedFormFields]);
    }
  };

  const incomeGroupDropDown = createDropdownField(
    axiosPrivate,
    "income_group_id",
    "income_group_id",
    IncomeGroup,
    `${financesIncomeGroupApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}&income_group_id=1'`,
    "",
    6
  );
  incomeGroupDropDown.onChange = async (id, updatedFields) => {
    const nextField = updatedFields.find(
      (field: any) => field.id === "income_class_id"
    );
    if (nextField) {
      const endPoint = `${financesIncomeClassApi}?organisation_id=${userOrganisationId}&income_group_id=${id}`
      await nextField.fetchOptions(id, false, endPoint);
      const updatedFormFields = updatedFields.map((field: any) => {
        if (field.id === "income_group_id") {
          return { ...field, value: id };
        }
        return field;
      });
      setFormFields([...updatedFormFields]);
    }
  };

  const incomeClassDropDown = createDropdownField(
    axiosPrivate,
    "income_class_id",
    "income_class_id",
    IncomeClass,
    `${financesIncomeClassApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}&income_category_id=1`,
    "",
    6
  );
  incomeClassDropDown.onChange = async (id, updatedFields) => {
    const nextField = updatedFields.find(
      (field: any) => field.id === "income_type_id"
    );
    if (nextField) {
      const endPoint = `${financesIncomeTypeApi}?organisation_id=${userOrganisationId}&income_class_id=${id}`
      await nextField.fetchOptions(id, false, endPoint);
      const updatedFormFields = updatedFields.map((field: any) => {
        if (field.id === "income_class_id") {
          return { ...field, value: id };
        }
        return field;
      });
      setFormFields([...updatedFormFields]);
    }
  };

  const incomeTypeDropDown = createDropdownField(
    axiosPrivate,
    "income_type_id",
    "income_type_id",
    IncomeType,
    `${financesIncomeTypeApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}&income_type_id=17`,
    "",
    6
  );

  useLayoutEffect(() => {
    //?? Updates all fields once component is mounted
    (async function () {
      const updatedFields = [
        incomeCategoryDropDown,
        incomeGroupDropDown,
        incomeClassDropDown,
        incomeTypeDropDown,
        ...formFields,
      ];
      await incomeCategoryDropDown.fetchOptions();
      setFormFields(updatedFields);
    })();
  }, []);

  const tableColumns = [
    {
      name: Name,
      selector: (row: (typeof data)[0]) => `${row.name}`,
      sortable: true,
      center: false,
    },
    {
      name: IncomeType,
      selector: (row: (typeof data)[0]) => `${row.income_type.name}`,
      sortable: true,
      center: false,
    },
    {
      name: IncomeClass,
      selector: (row: (typeof data)[0]) =>
        `${row.income_type.income_class.name}`,
      sortable: true,
      center: false,
    },
    {
      name: IncomeGroup,
      selector: (row: (typeof data)[0]) =>
        `${row.income_type.income_class.income_group.name}`,
      sortable: true,
      center: false,
    },
    {
      name: IncomeCategory,
      selector: (row: (typeof data)[0]) =>
        `${row.income_type.income_class.income_group.income_category.name}`,
      sortable: true,
      center: false,
    },
    {
      name: Status,
      selector: (row: (typeof data)[0]) => `${row.is_active}`,
      sortable: true,
      center: true,
      cell: (row: (typeof data)[0]) => StatusRow(row),
    },
    {
      name: CreatedBy,
      selector: (row: (typeof data)[0]) =>
        `${formatDateWithTimeZone(row.created_at)}`,
      sortable: false,
      center: false,
    },

    {
      name: ModifiedBy,
      selector: (row: (typeof data)[0]) =>
        `${formatDateWithTimeZone(row.updated_at)}`,
      sortable: false,
      center: false,
    },
  ];

  const handleEdit = (row: (typeof data)[0] | any) => {
    setViewModalOpen(true);
    setEditMode(true);

    incomeCategoryDropDown.onChange(
      row.income_type.income_class.income_group.income_category.id,
      formFields
    );

    row.income_category_id = row.income_type.income_class.income_group.income_category.id
    row.income_group_id = row.income_type.income_class.income_group.id
    row.income_class_id = row.income_type.income_class.id
    row.income_type_id = row.income_type.id

    incomeGroupDropDown.onChange(
      row.income_type.income_class.income_group.id,
      formFields
    );

    incomeClassDropDown.onChange(row.income_type.income_class.id, formFields);

    setSelectedRowData(row);
  };

  const { layoutURL } = useContext(CustomizerContext);
  const newBtn = `${process.env.PUBLIC_URL}/finance/settings/income-description/create/${layoutURL}`;
  //   const [isLoading, setIsLoading] = useState(true);

  const fetchData = () => {
    setLoading(true);
    axiosPrivate
      .get(
        `${financesIncomeDescriptionApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}`
      )
      .then((res) => {
        const response: IncomeDescriptionResponse[] = res.data;
        setData(response);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          toast.error(err.response.data.detail);
        } else {
          toast.error('Something Went Wrong');
        }
      })
      .finally(() => {
        setLoading(false);
      });
    //console.log(data);
  };

  const [loading, setLoading] = useState(true);
  useLayoutEffect(() => {
    fetchData();
    //console.log(data);
  }, []);
  const [data, setData] = useState<IncomeDescriptionResponse[]>([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<
    (typeof data)[0] | null
  >(null);
  const [editMode, setEditMode] = useState(false);

  const handleView = (row: (typeof data)[0]) => {
    setViewModalOpen(true);
    setEditMode(false);
    setSelectedRowData(row);
  };

  const handleEditRec = async (
    id: number | string,
    editRecord: (typeof data)[0]
  ) => {
    //??dynmically send the selected income_type_id to the server
    await axiosPrivate
      .put(`${financesIncomeDescriptionApi}/${id}`, editRecord)
      .then((_res) => {
        const updatedData = data.map((row) =>
          row.id === selectedRowData!.id ? { ...row, ..._res.data } : row
        );
        setData(updatedData);
        toast.success(`${_res.data.name} Editted Successfully.`)
        //fetchData();
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          toast.error('Validation Errors');
        } else if (err.response && err.response.status === 400) {
          toast.error(err.response.data.detail);
        } else {
          toast.error('Something Went Wrong');
        }
        throw err;
        //toast.error(err.response.message || "Whoops! Something went wrong");
      });
    //console.log(editRecord);
  };

  const memoizedHandleEdit = useMemo(
    () => handleEditRec,
    [data, selectedRowData]
  );

  return {
    data,
    loading,
    tableColumns,
    viewModalOpen,
    selectedRowData,
    editMode,
    newBtn,
    title,
    formFields,
    setViewModalOpen,
    handleView,
    handleEdit,
    memoizedHandleEdit,
  };
}
